module.exports = "/_next/static/images/logo-personalized-6649c5ce52e3c08e40d733f57d671c64.png";